import * as React from 'react';
import  {RenderEngineKey} from '../constants';


export default function Child(props) {
    let excludeFieldsArr = [];
    if(props.IsPinnedCustomfields){
        excludeFieldsArr =[RenderEngineKey.PropertyLocation, RenderEngineKey.CustomerName, RenderEngineKey.AdjusterName, RenderEngineKey.WorkkardNumber, RenderEngineKey.WorkkardTitle];
    } else {
        excludeFieldsArr =props.workkard.TemplateShortName != "COMMERCIALLITIGATION"?
        [RenderEngineKey.PropertyLocation, RenderEngineKey.CustomerName, RenderEngineKey.AdjusterName, RenderEngineKey.CarrierContactName, RenderEngineKey.CarrierContactPhone, RenderEngineKey.CarrierContactEmail, RenderEngineKey.CarrierClaimNumber, RenderEngineKey.BuildingType, RenderEngineKey.BuildingDescription, RenderEngineKey.WorkkardNumber, RenderEngineKey.WorkkardTitle]
        :[RenderEngineKey.PropertyLocation, RenderEngineKey.CustomerName, RenderEngineKey.AdjusterName, RenderEngineKey.CarrierContactName, RenderEngineKey.CarrierContactPhone, RenderEngineKey.CarrierContactEmail, RenderEngineKey.CarrierClaimNumber, RenderEngineKey.WorkkardNumber, RenderEngineKey.WorkkardTitle];
       props.IsForClaimWorkkard ? excludeFieldsArr.push(RenderEngineKey.Track) : null;
        props.workkard.TemplateShortName != "COMMERCIAL" ? excludeFieldsArr.push("Carrier") : null;
    }        
    return(
        <div className="wkDetailInfo wkClaimInfo faster animated fadeInDown">
            {
                props.renderFields({
                    excludeFields: excludeFieldsArr,
                    showLabel:true,
                    workkardDetail: props.workkard
                })
            }
        </div>
    );
}